import React, { useState, useEffect } from "react";
import ScrollToTop from "../components/scroll-to-top";
import SEO from "../components/seo";
import AboutContainer from "../containers/about";
import BrandContainer from "../containers/global/brand/index";
import FunFactContainer from "../containers/global/funfact";
import IconBoxContainer from "../containers/global/icon-box";
import NewsletterArea from "../containers/global/newsletter";
import PageBanner from "../containers/global/page-banner";
import TestimonialReverse from "../containers/global/testimonial-reverse";
import ServiceListContainer from "../containers/service/service-list";
import Footer from "../layouts/footer";
import Header from "../layouts/header";
import Layout from "../layouts/index";
import { baseURL } from "../App";
import axios from "axios";
import Loading from "../components/Loading";
import SectionTitle from "../components/section-title";
import { Link } from "react-router-dom";



const Tokenomics = () => {


    const [tokenomics, settokenomics] = useState(null);
    const [settings, setSettings] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchtokenomics = async () => {
            try {
                const response = await axios.get(`${baseURL}items/tokenomics?fields=*.*`);
                if (response.data) {
                    settokenomics(response.data.data);
                } else {
                    console.error("Invalid data format received from Directus.");
                }
            } catch (error) {
                console.error("Error fetching tokenomics data from Directus:", error);
            }
        };

        const fetchSettings = async () => {
            try {
                const response = await axios.get(`${baseURL}items/settings?fields=*.*`);
                if (response.data) {
                    setSettings(response.data.data);
                } else {
                    console.error("Invalid data format received from Directus.");
                }
            } catch (error) {
                console.error("Error fetching settings data from Directus:", error);
            }
        };

        // Tüm verilerin yüklenmesini bekleyin
        Promise.all([fetchtokenomics(), fetchSettings()]).then(() => {
            setLoading(false); // Veriler tamamen yüklendiğinde loading false olur
        });
    }, []);



    if (tokenomics === null || settings === null) {
        return <Loading />;
    }


    return (
        <React.Fragment>
            <Layout>
                <SEO title={tokenomics?.seo_title} />
                <div className="wrapper">
                    <Header />

                    <PageBanner
                        title={`${tokenomics?.banner_title} `}
                        excerpt={`${tokenomics?.banner_text} `}
                        image={`${baseURL}assets/${tokenomics.banner_img?.id}`}
                    />
                    <br />

                    {settings?.tokenomics_active === true ? (
                        <div className="about-us position-relative">
                            <div className="container">
                                <div className="row mb-n7 align-items-center">
                                    <div className="col-xl-3 col-md-6 offset-xl-1 mb-7">
                                        <div className="about-content mt-4">
                                            <SectionTitle
                                                classOption="title-section"
                                                subTitle={`${tokenomics?.title} `}
                                                title=""
                                            />
                                            <h4 className="text-white mb-3" >
                                                {`${tokenomics?.text} `}
                                            </h4>
                                        </div>
                                    </div>
                                    <div className="col-xl-8 order-lg-first col-md-6 mb-7">
                                        <div
                                            className="about-photo scene text-center text-lg-left"
                                            id="scene"
                                        // ref={sceneEl}
                                        >
                                            <div data-depth="0.2">
                                                <img
                                                    src={`${baseURL}assets/${tokenomics.tokenomics_img?.id}`}
                                                    alt="about"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>


                    ) : (
                        ""
                    )}



                    <Footer />
                    <ScrollToTop />
                </div>
            </Layout>
        </React.Fragment>
    );
};

export default Tokenomics;
